export const database = {
    shows : [
        {
            id: 1,
            date : "03/17/2023",
            eventName: "Lucky Fest",
            locationName : "Strawberry Basement",
            locationCityState : "Nashville, TN",
            eventRsvp: "https://www.strawberryberryband.com/tickets/store/p/st-patricks-day-lucky-fest",
            eventTickets: "https://www.strawberryberryband.com/tickets/store/p/st-patricks-day-lucky-fest"

        },
        {
            id: 2,
            date : "04/08/2023",
            locationName : "The Cobra",
            locationCityState : "Nashville, TN",
            eventRsvp: "https://www.masonpacemusic.com/events/april-8-nashville-tn",
            eventTickets: "https://www.masonpacemusic.com/events/april-8-nashville-tn"
        },
        {
            id: 3,
            date : "04/07/2023",
            locationName : "Springwater Supper Club & Lounge",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 4,
            date : "04/16/2023",
            locationName : "Springwater Supper Club & Lounge",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 5,
            date : "04/24/2023",
            locationName : "Cafe Coco",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 6,
            date : "05/27/2023",
            locationName : "404 Bar And grill",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 7,
            date : "06/03/2023",
            locationName : "Bring It Back games",
            locationCityState : "Shelbyville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 8,
            date : "08/11/2023",
            locationName : "Brooklyn Bowl",
            locationCityState : "Nashville, TN",
            eventRsvp: "https://www.ticketmaster.com/lore-nashville-tennessee-08-11-2023/event/1B005EEBBB8C3351",
            eventTickets: "https://www.ticketmaster.com/lore-nashville-tennessee-08-11-2023/event/1B005EEBBB8C3351"
        },
        {
            id: 9,
            date : "10/07/2023",
            locationName : "The Cobra",
            locationCityState : "Nashville, TN",
            eventRsvp: "https://cobranashville.com/event/mick-blankenship-w-jesse-kramer-lowfye50/",
            eventTickets: "https://www.eventbrite.com/e/mick-blankenship-w-jesse-kramer-lowfye50-tickets-689049795487?aff=oddtdtcreator"
        },
        {
            id: 10,
            date : "08/01/2026",
            locationName : "The End",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 11,
            date : "08/14/2026",
            eventName: "with Framing Hanley",
            locationName : "The Basement East",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
        {
            id: 12,
            date : "10/04/2026",
            eventName: "with Xavier Wulf",
            locationName : "Eastside Bowl",
            locationCityState : "Nashville, TN",
            eventRsvp: "",
            eventTickets: ""
        },
    ],
}